import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CheckSessionService, UserPreferencesService } from '@thehubz/client/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lh-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  hasHeadline = false;

  private routerSubscription?: Subscription;

  constructor(
    private userPreferencesService: UserPreferencesService,
    private router: Router,
    private checkSessionService: CheckSessionService,
  ) {
    const urlsWithHeadline = ['/assets/detail/', '/collections/collection-asset-list/'];

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.hasHeadline = Boolean(urlsWithHeadline.find((urlPattern) => this.router.url.includes(urlPattern)));
      }
    });
  }

  ngOnInit() {
    this.userPreferencesService.createUserPreference();

    this.checkSessionService.start(() => {
      this.checkSessionService.defaultLogoutRoutine(false);
      this.router.navigate(['/']).then(() => {
        window.location.reload();
      });
    });
  }

  ngOnDestroy() {
    this.checkSessionService.stop();
    this.routerSubscription?.unsubscribe();
  }
}
